import React from 'react';
import { Col, Form, FormGroup, Label, Input, Row, FormFeedback } from "reactstrap";

export const FormSite = (props) => {
    const {
        handleInputChange, validaciones, name,
    } = props;

    const {
        name_valid,
    } = validaciones

    return (
        <Form className='' role="form" >

            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>Nombre del sitio <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className='input-admision'
                            type='text'
                            name="name"
                            onChange={handleInputChange}
                            value={name}
                            autoComplete="off"
                            invalid={name_valid}
                        />
                        <FormFeedback>Minimo 3 caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>


        </Form>
    )
}